export default __webpack_public_path__ + "static/media/file18.e99ced29.jpg";